import ScrollReveal from '@/components/base/ScrollReveal';
import { siteInfo } from '@/mocks/dramas';

const stats = [
  { label: '海量剧集', value: siteInfo.stats.totalDramas, icon: 'ri-movie-2-line' },
  { label: '日活用户', value: siteInfo.stats.dailyVisitors, icon: 'ri-user-heart-line' },
  { label: '更新频率', value: siteInfo.stats.updateSpeed, icon: 'ri-refresh-line' },
  { label: '用户评分', value: siteInfo.stats.userRating, icon: 'ri-star-line' },
];

export default function StatsSection() {
  return (
    <ScrollReveal>
    <section className="bg-background-100/50 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            <i className="ri-bar-chart-2-line text-accent-500 mr-2"></i>
            平台数据
          </h2>
          <p className="text-sm text-foreground-500 mt-1">千万用户的选择，值得信赖</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-xl p-6 text-center border border-background-300/60 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center text-accent-500">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-1">
                {stat.value}
              </p>
              <p className="text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    </ScrollReveal>
  );
}